import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { cloneDeep } from 'lodash';

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';

export default function AddPlugCustomTemplateRuleModal(props) {
  const {
    show,
    onHide,
    showToast,
    isSaving,
    setIsSaving,
    setTemplates,
    setActiveRuleId,
    ruleType,
    activeTemplateId,
    organizationId,
  } = props;

  const [templateRuleName, setTemplateName] = useState('');

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (templateRuleName) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [templateRuleName]);

  const addTemplateRule = (e) => {
    e.preventDefault();
    setIsSaving(true);
    ApiServiceServerless.post(
      `/custom_templates/rule/${activeTemplateId}`,
      {
        name: templateRuleName,
        rule_type: ruleType,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        setTemplates((prev) =>
          prev.map((template) => {
            if (template.id !== activeTemplateId) return template;
            let new_template = cloneDeep(template);
            new_template.rules = [...new_template.rules, res.data];
            return new_template;
          })
        );
        setActiveRuleId(res.data.id);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsSaving(false);
        resetModal();
      });
  };

  const resetModal = () => {
    setTemplateName('');
  };

  useEffect(() => {
    if (show) {
      resetModal();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Add Template Rule</Modal.Header>
      <Form onSubmit={addTemplateRule}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              {'Rule Name'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setTemplateName(e.target.value)}
              />
            </Form.Row>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={onHide}
            submitDisabled={disabled}
            isSubmitting={isSaving}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
